var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngineeringinline = function SvgEngineeringinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#engineering_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "m15.157 3.268-1.66 1.66a.5.5 0 0 1-.708 0l-1.716-1.716a.5.5 0 0 1 0-.707l1.661-1.66a4.3 4.3 0 0 0-1.501-.17 3.776 3.776 0 0 0-3.243 4.88l-6.553 5.802a2.27 2.27 0 0 0 .667 3.816 2.27 2.27 0 0 0 2.54-.609l5.803-6.552c.619.19 1.275.225 1.91.103a3.75 3.75 0 0 0 2.868-2.628 4.4 4.4 0 0 0-.069-2.219Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "engineering_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEngineeringinline;